export default __webpack_public_path__ + "static/media/doragon.b9976573.png";